import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { GwrFormService } from '../../../gwr-form.service';
import { BauortComponent } from '../../../../shared/widgets/bauort/bauort.component';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { BauprojektStandardRequestMeta, GwrbauprojektService } from '../../../../core/gwr-api';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { ProjektstatusComponent } from '../../../../shared/widgets/projektstatus/projektstatus.component';
import { DatepickerComponent } from '../../../../shared/datepicker/datepicker.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-bauprojekt-suche-standard',
  templateUrl: './gwr-bauprojekt-suche-standard.component.html',
  styleUrls: ['./gwr-bauprojekt-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    BauortComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    ProjektstatusComponent,
    DatepickerComponent,
    TranslatePipe
  ]
})
export class GwrBauprojektSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(BauortComponent, { static: false })
  private bauort: BauortComponent;

  searchForEgrid: boolean;

  standard: BauprojektStandardRequestMeta;
  private subscription: Subscription;
  onTouched: () => void;

  constructor(
    stateService: SearchStateService,
    private bauprojektService: GwrbauprojektService,
    private formService: GwrFormService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.bauprojektService.searchBauprojektStandardTemplate().subscribe((template) => {
      this.standard = this.copyLastRequest(template);
      this.searchForEgrid = template.mEgrid.access !== 'DEACTIVATED';
    });
  }

  onSubmit(): void {
    if (this.standard.egrid && this.standard.egrid.value) {
      this.standard.egrid.value = this.standard.egrid.value.replace(/\s/g, '');
    }
    this.stateService.lastSearchMode = SearchMode.searchStandard;
    this.stateService.lastRequest = this.standard;
    this.formService.submit(this.form, SearchMode.searchStandard, this.standard, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.bauprojektService.searchBauprojektStandardTemplate().subscribe((template) => {
      this.standard = template;
      this.bauort.focus();
      this.bauort.ngOnInit();
    });
  }

  emptyBauorteSearch() {
    this.bauort.onClear();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
